var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Data } from "./data";
import { OrderItem } from "./order-item";
import { MathUtils } from "..";
var Benefit = /** @class */ (function (_super) {
    __extends(Benefit, _super);
    function Benefit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Benefit";
        _this.max = 1; //using times
        _this.fixedamount = 0; //discount reduced to a fixed amount
        _this.applied = false; //for gift/unlock benefit, when the gift or unlock cat found, applied = true
        _this.used = 0;
        return _this;
    }
    /**clone original benefit as a new benefit object**/
    Benefit.cloneBenefit = function (ben) {
        var b = new Benefit();
        if (ben.type)
            b.type = ben.type;
        if (ben.amount)
            b.amount = ben.amount;
        if (ben.code)
            b.code = ben.code;
        if (ben.code2)
            b.code2 = ben.code2;
        if (ben.max)
            b.max = ben.max;
        if (ben.percent)
            b.percent = ben.percent;
        if (ben.applied)
            b.applied = ben.applied;
        if (ben.used)
            b.used = ben.used;
        if (ben.display)
            b.display = ben.display;
        if (ben.display2)
            b.display2 = ben.display2;
        if (ben.fixedamount)
            b.fixedamount = ben.fixedamount;
        return b;
    };
    /**
     * @param order, order
     * @param condition, discount's main condition
     * @param promo, discount
     * @param orderitem (optional), used only when discount is of item level
     * calculate discount amount
     * */
    Benefit.prototype.apply = function (order, condition, promo, orderItem, tmpCounter, store, roundPrecision) {
        var _this = this;
        if (orderItem === void 0) { orderItem = null; }
        if (tmpCounter === void 0) { tmpCounter = 0; }
        if (roundPrecision === void 0) { roundPrecision = 1; }
        var discount = 0; //discounted amount after applying this benefit
        switch (this.type) {
            case 'fixedamount': {
                if (condition.type == "itemgroup") {
                    if (promo.available >= this.max) {
                        break;
                    }
                }
                var count = 1;
                if (tmpCounter > count) {
                    count = tmpCounter;
                }
                // if (condition.type === "total") {
                //     //do nothing
                // } else if (condition.level === "item" && condition.type !== "itemgroup_count") {
                //     //condition type = item or itemgroup or exitemgroup
                //     if (orderItem.quantity) count = orderItem.quantity;
                // }
                var netAmount = 0;
                var mainItem = OrderItem.getMainItem(orderItem);
                if (this.fixedamount < orderItem.total) {
                    netAmount = (mainItem.price - this.fixedamount);
                }
                else {
                    netAmount = this.fixedamount;
                }
                discount = this.round(netAmount * count);
                if (orderItem) {
                    orderItem.discount = discount;
                    if (orderItem.discounts && orderItem.discounts.length > 0) {
                        if (orderItem.discounts.indexOf(promo) === -1) {
                            orderItem.discounts.push(promo);
                        }
                    }
                    else {
                        orderItem.discounts.push(promo);
                    }
                }
                this.setMainItemDiscounted(orderItem, discount, promo);
                //for itemgroup_count type conditon, discountClaimed will be updated at condition.ts
                if ((condition.type != "itemgroup_count" && condition.type != "item_count") && condition.type != "item")
                    orderItem["discountClaimed"] += count;
                promo.available += count;
                break;
            }
            case 'amount': {
                if (this.amount > 0) {
                    if (condition.type == "itemgroup") {
                        if (promo.available >= this.max) {
                            break;
                        }
                    }
                    var count = 1;
                    if (condition.type === "total") {
                        var total = condition.discounted ? order.grandTotal : order.total;
                        total = condition.applyHandling ? total + order.handling : total;
                        count = Math.floor(total / condition.amount);
                    }
                    else if (condition.level === "item" && condition.type !== "itemgroup_count" && condition.type !== "item_count") {
                        //condition type = item or itemgroup or exitemgroup
                        if (orderItem.quantity)
                            count = orderItem.quantity;
                    }
                    else if (condition.type === 'itemgroup_count' || condition.type === 'item_count') {
                        count = tmpCounter;
                    }
                    if (count > this.max)
                        count = this.max;
                    if (this.amount)
                        discount = this.round(this.amount * count);
                    if (discount > order.grandTotal) {
                        promo.overpay = this.round(discount - order.grandTotal);
                    }
                    if (orderItem) {
                        orderItem.discount = discount;
                        if (orderItem.discounts && orderItem.discounts.length > 0) {
                            if (orderItem.discounts.indexOf(promo) === -1) {
                                orderItem.discounts.push(promo);
                            }
                        }
                        else {
                            orderItem.discounts.push(promo);
                        }
                    }
                    promo.available += count;
                }
                break;
            }
            //split two cases: order level and item level discount
            //when in item level, promotion group items should be calculate separately
            case 'percent': {
                if (this.percent) {
                    //The precision of discount lookup from currency.
                    // Check out precision will look on menu settings , otherwise fall back to look currency
                    // let roundPrecision = orderManager.getPrecision();
                    //let roundPrecision = orderManager.getStoreGrandTotalPrecision(store.currency);
                    var count_1 = 1;
                    if (condition.level == "order") {
                        //todo?? not first discount
                        var discountableTotal_1 = condition.discounted ? order.grandTotal : order.total;
                        // let discountableTotal = order.total;
                        // TODO: the round is step 0.5 now. Should change round step based on currency?
                        var temp = promo.conditions.find(function (condition) { return condition.traverseItemsDiscountable; });
                        if (temp) {
                            order.orderitems.forEach(function (oi) {
                                var orderItemDiscount = 0;
                                oi.items.forEach(function (item) {
                                    if (!item.discountable) {
                                        discountableTotal_1 -= item.price * (item.quantity * oi.quantity);
                                    }
                                    else {
                                        orderItemDiscount += item.price * (item.quantity * oi.quantity);
                                    }
                                });
                                if (oi.discounts && oi.discounts.length > 0) {
                                    oi.discounts.forEach(function (dis) {
                                        if (dis.level && dis.level == "order") {
                                            oi.discount = orderItemDiscount * _this.percent / 100.0;
                                        }
                                        else {
                                            oi.discount += orderItemDiscount * _this.percent / 100.0;
                                        }
                                    });
                                }
                                else {
                                    oi.discount += orderItemDiscount * _this.percent / 100.0;
                                    oi.discounts.push(promo);
                                }
                                oi.discount = _this.orderItemDiscountRound(oi.discount, roundPrecision, store);
                                if (oi.discounts.indexOf(promo) === -1) {
                                    oi.discounts.push(promo);
                                }
                            });
                        }
                        else {
                            // TODO: handle isMainItemOnly case
                            // traverseItemsDiscountable is false, only apply main item discountable to all items
                            order.orderitems.forEach(function (oi) {
                                var orderItemDiscount = 0;
                                var mainItem = oi.items[0];
                                var discountable = (mainItem.marker && mainItem.marker == "alone" && !mainItem.discountable) || (mainItem.marker !== "alone" && !oi.items[0].discountable) || !mainItem.discountable;
                                oi.items.forEach(function (item) {
                                    if (discountable) {
                                        discountableTotal_1 -= item.price * (item.quantity * oi.quantity);
                                    }
                                    else {
                                        orderItemDiscount += item.price * (item.quantity * oi.quantity);
                                    }
                                });
                                if (oi.discounts && oi.discounts.length > 0) {
                                    oi.discounts.forEach(function (dis) {
                                        if (dis.level && dis.level == "order") {
                                            oi.discount = orderItemDiscount * _this.percent / 100.0;
                                        }
                                        else {
                                            oi.discount += orderItemDiscount * _this.percent / 100.0;
                                        }
                                    });
                                }
                                else {
                                    oi.discount += orderItemDiscount * _this.percent / 100.0;
                                    oi.discounts.push(promo);
                                }
                                oi.discount = _this.orderItemDiscountRound(oi.discount, roundPrecision, store);
                                if (oi.discounts.indexOf(promo) === -1) {
                                    oi.discounts.push(promo);
                                }
                            });
                        }
                        discount = this.discountRound(discountableTotal_1, roundPrecision, store);
                    }
                    else if (condition.level == "item") {
                        if (orderItem.quantity)
                            count_1 = Math.min(orderItem.quantity, this.max);
                        if (tmpCounter > count_1) {
                            count_1 = tmpCounter;
                        }
                        //Spilt Promotion Group Item
                        var clone = __assign({}, orderItem);
                        var mainItem_1 = OrderItem.getMainItem(clone);
                        var pgroupItems = [];
                        if (mainItem_1.pgroupId) {
                            var pgroup = orderItem.groups.find(function (group) {
                                return group.id === mainItem_1.pgroupId;
                            });
                            pgroupItems = pgroup && pgroup.items;
                        }
                        // check every item
                        discount = 0;
                        if (mainItem_1.discountable) {
                            var discountableTotal_2 = orderItem.total * count_1;
                            if (condition.isMainItemOnly()) {
                                var mainItem_2 = orderItem.items[0];
                                orderItem.items.forEach(function (item) {
                                    discountableTotal_2 -= item.price * (item.quantity * orderItem.quantity);
                                });
                                if (mainItem_2.discountable) {
                                    discountableTotal_2 += mainItem_2.price * (mainItem_2.quantity * orderItem.quantity);
                                }
                            }
                            else {
                                var target_1 = true;
                                if (condition.type === 'itemgroup' || condition.type === 'itemgroup_count') {
                                    target_1 = false;
                                }
                                var temp = promo.conditions.find(function (condition) { return target_1 === condition.traverseItemsDiscountable; });
                                if (temp) {
                                    orderItem.items.forEach(function (item) {
                                        if ((item.marker && item.marker == "alone" && !item.discountable) || (item.marker !== "alone" && !orderItem.items[0].discountable) || !item.discountable) {
                                            discountableTotal_2 -= item.price * (item.quantity * orderItem.quantity);
                                        }
                                    });
                                }
                                else {
                                    //boolean mainDiscountable = oi.getFlattenItemsWithModifiers().get(0).getDiscountable();
                                    //
                                    // 			for(Item item: items){
                                    // 				if(mainDiscountable){
                                    // 					total += item.getPrice() * item.getQuantity();
                                    // 				}
                                    // 			}
                                    var mainItem_3 = orderItem.items[0];
                                    var mainDiscountable = mainItem_3.discountable;
                                    orderItem.items.forEach(function (item, i) {
                                        if (!mainItem_3.discountable) {
                                            discountableTotal_2 -= item.price * (item.quantity * orderItem.quantity);
                                        }
                                        else if (mainItem_3.discountable && i !== 0) {
                                            discountableTotal_2 -= item.price * (item.quantity * orderItem.quantity);
                                        }
                                    });
                                }
                            }
                            discount = this.discountRound(discountableTotal_2, roundPrecision, store);
                        }
                        if (pgroupItems != null && pgroupItems.length > 0) {
                            pgroupItems.forEach(function (pitem) {
                                if (!pitem.discountable) {
                                    discount -= (pitem.price * pitem.quantity * _this.percent / 100.00 * count_1);
                                }
                            });
                        }
                        discount = this.orderItemDiscountRound(discount, roundPrecision, store);
                        orderItem.discount = discount;
                        if (orderItem.discounts && orderItem.discounts.length > 0) {
                            if (orderItem.discounts.indexOf(promo) === -1) {
                                orderItem.discounts.push(promo);
                            }
                        }
                        else {
                            orderItem.discounts.push(promo);
                        }
                    }
                    promo.available += count_1;
                }
                break;
            }
            //TODO NOT YET APPLIED
            case 'offer': {
                if (this.code) {
                }
                break;
            }
            //for type==gift, only mark applied as true when gift is available
            case 'gift': {
                if (this.code) {
                    var item = this.findGift(promo);
                    this.applied = !!item;
                }
                break;
            }
            //for type==unlock, only mark applied as true when unlock category is available
            case 'unlock': {
                if (this.code) {
                    var cat = this.fetchUnlock(promo);
                    var used_1 = 0;
                    if (cat !== null) {
                        order.orderitems.forEach(function (oi) {
                            if (oi.categoryId === _this.code) {
                                used_1 += oi.quantity;
                                console.log("used+:", oi.quantity);
                            }
                        });
                    }
                    console.log("used:", used_1);
                    this.used = used_1;
                    //this.applied = used === 0; //if not yet used then apply this benefit
                    if (used_1 <= 0) {
                        this.applied = true;
                    }
                }
                break;
            }
            default:
                break;
        }
        return discount;
    };
    /**get discount unlocked category**/
    Benefit.prototype.fetchUnlock = function (promo) {
        if (promo.unlocks) {
            for (var _i = 0, _a = promo.unlocks; _i < _a.length; _i++) {
                var unlock = _a[_i];
                if (unlock.id == this.code) {
                    return unlock;
                }
            }
        }
        return null;
    };
    /**get discount gift**/
    Benefit.prototype.findGift = function (promo) {
        if (promo.gifts) {
            for (var _i = 0, _a = promo.gifts; _i < _a.length; _i++) {
                var gift = _a[_i];
                if (gift && gift.groups && gift.groups[0] && gift.groups[0].items && gift.groups[0].items.length > 0) {
                    for (var _b = 0, _c = gift.groups[0].items; _b < _c.length; _b++) {
                        var item = _c[_b];
                        if (item.id == this.code)
                            return item;
                    }
                }
            }
        }
        return null;
    };
    /*getDisplay() {
        this.display = "";
        if (this.amount) {
            this.display = "-" + this.amount;
        } else if (this.percent) {
            this.display = "-" + this.percent + "%";
        }
        return this.display;
    }*/
    Benefit.prototype.isDiscount = function () {
        return this.type !== "unlock";
        //unlock type always is of lowest priority
    };
    Benefit.prototype.isItemDiscount = function () {
        switch (this.type) {
            case "amount":
                return true;
            default:
                break;
        }
        return false;
    };
    Benefit.prototype.setMainItemDiscounted = function (oi, amount, discount) {
        if (oi.groups || oi.groups.length == 0)
            return;
        oi.groups[0].items.forEach(function (item) {
            item.discounted = true;
            item.discount = amount;
            item.discountCode = discount.backendId;
            item.discountedId = discount.id;
        });
    };
    Benefit.prototype.round = function (value) {
        return MathUtils.round(value, 2);
    };
    Benefit.prototype.toProperty = function (name, value) {
        return value;
    };
    /** 有些pos要求每個orderitem有discount，而且要按照他們的計算要求, 所以特别使用了discountRoundMode**/
    Benefit.prototype.orderItemDiscountRound = function (value, precision, store) {
        if (store && store.menu && store.menu.settings && store.menu.settings.discountRoundMode) {
            if (store.menu.settings.discountRoundMode === 'rounddown') {
                return MathUtils.floor(value, precision);
            }
            else if (store.menu.settings.discountRoundMode === 'roundup') {
                return MathUtils.ceil(value, precision);
            }
            else if (store.menu.settings.discountRoundMode === 'roundtonear5') {
                return MathUtils.round(value, precision);
            }
            else {
                return MathUtils.round(value, precision);
            }
        }
        else {
            return MathUtils.round(value, precision);
        }
    };
    Benefit.prototype.discountRound = function (value, precision, store) {
        var discountRoundMethod;
        var p = precision;
        if (store && store.menu && store.menu.settings) {
            discountRoundMethod = store.menu.settings.discountRoundMethod;
            if (typeof store.menu.settings.discountRoundingPrecision === 'number') {
                p = store.menu.settings.discountRoundingPrecision;
            }
        }
        var roundTo = 10;
        if (p != null && typeof p === 'number') {
            if (p === 0) {
                roundTo = 1;
            }
            else {
                roundTo = Math.pow(10, p);
            }
        }
        switch (discountRoundMethod) {
            case 'round2discount':
                return Math.round(value * this.percent / 100.0 * roundTo) / roundTo;
            case 'round2net':
                return value - Math.round(value * (1 - this.percent / 100.0) * roundTo) / roundTo;
            default:
                return value * this.percent / 100.0;
        }
    };
    return Benefit;
}(Data));
export { Benefit };
//# sourceMappingURL=benefit.js.map